export default "__VITE_ASSET__CLBzd9Mu__"